<template>
  <BfAccordion
    :title="t('setup.parts.crankset')"
    :open-by-default="lengthFilter"
  >
    <template #header-right>
      <BfButton
        v-if="!lengthFilter"
        :type="ButtonType.Outlined"
        @click.stop="toggleFilter"
      >
        {{ t('common.change') }}
      </BfButton>
      <BfBadge
        :color="
          selectedMeasurement?.crankset.active !== undefined
            ? Colors.Success
            : Colors.Danger
        "
      />
    </template>
    <BfDescriptionList :label="t('setup.crankset.length')">
      {{
        selectedMeasurement?.crankset.active
          ? `${selectedMeasurement?.crankset.active} ${t('common.unit.mm')}`
          : '-'
      }}
    </BfDescriptionList>

    <CranksetFiltersLength
      v-if="lengthFilter"
      @cancel="toggleFilter"
      @save="toggleFilter"
    />
  </BfAccordion>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMeasurementStore } from '@/store/measurementStore'
import {
  Colors,
  ButtonType,
  BfBadge,
  BfAccordion,
  BfButton,
  BfDescriptionList,
} from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import CranksetFiltersLength from '@/components/setup/crankset/CranksetFiltersLength.vue'

const { t } = useI18n()
const measurementStore = useMeasurementStore()
const { selectedMeasurement } = storeToRefs(measurementStore)

const lengthFilter = ref(false)

const toggleFilter = () => {
  lengthFilter.value = !lengthFilter.value
}
</script>

<style lang="scss"></style>
